import { throttle } from 'throttle-debounce';
import UrlGeneration from "../libs/UrlGeneration";
import filter from './filter';
export default new (class Search {
    constructor() {
        this.wraperSearch = 'search';
        this.searchResetBtn = 'search-reset';
        this.initHandler();
        this.bindOnSibmit();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.querySelectorAll(`.${this.wraperSearch}`).forEach((wrap) => {
            if (wrap.classList.contains('_inited')) return;
            wrap.classList.add('_inited')
            const form = wrap.querySelector('.search-form:not(.search-form-main)');
            const onClickOutside = (e) => {
                if (wrap.classList.contains('focus-search') && !form.contains(e.target)) {
                    wrap.classList.remove('focus-search');

                    if(!wrap.closest('.search-popup')) {
                        wrap.classList.remove('input-search');
                    }
                }
            }
            document.body.addEventListener('click', onClickOutside)

            const search = throttle(500, (value) => {
                oc.ajax(form.dataset.handler, {
                    data: {
                        query: value
                    }
                });
            });

            const searchPopup = throttle(500, (value) => {
                const oldData = JSON.stringify(UrlGeneration.obParamList);
                UrlGeneration.clear();
                UrlGeneration.set('query', value);
                document.querySelectorAll('.filter-popup :checked').forEach(item => {
                    UrlGeneration.set(item.name, item.value);
                });
                UrlGeneration.update(true)
                oc.ajax(form.dataset.handler);
                UrlGeneration.obParamList = JSON.parse(oldData);
                UrlGeneration.update(true)
            })

            wrap.querySelector('input').addEventListener('focusin', (e) => {
                e.target.closest(`.${this.wraperSearch}`).classList.add('focus-search');
                this.InputSearch(e.target);
                if (e.target.value.length) {
                    e.target.closest('.filter-popup') ? searchPopup(e.target.value) : search(e.target.value);
                }
            });

            let oldValue = wrap.querySelector('input').value;
            wrap.querySelector('input').addEventListener('keyup', (e) => {
                if (e.target.value != oldValue) {
                    this.InputSearch(e.target);
                }
                if (e.target.value.length) {
                    e.target.closest('.filter-popup') ? searchPopup(e.target.value) : search(e.target.value);
                }
            })

        });

        document.querySelectorAll(`.${this.searchResetBtn}`).forEach((btn) => {
            if (btn.classList.contains('_inited')) return;
            btn.classList.add('_inited');
            btn.addEventListener('click', (e) => {
                let input = btn.closest(`.${this.wraperSearch}`).querySelector('input');
                input.value = '';
                this.InputSearch(input);
            });
        });

        
    }

    bindOnSibmit() {
        document.body.addEventListener('submit', (e) => {
            const form = e.target.closest('.search-form:not(.search-form-main)')
            if (form) {
                e.preventDefault();
                const query = form.elements['query'];

                UrlGeneration.replace('query', query.value);
                UrlGeneration.update();

                if (form.closest('.filter-popup')) {
                    filter.onPopupSubmit();
                } else if(form.closest('.search-recipes')) {
                    document.querySelectorAll('.search-form:not(.search-form-main)').forEach(form => {
                        form.elements['query'].setAttribute('value', query.value)
                        form.elements['query'].value = query.value;
                    });
                    filter.sHandler = document.querySelector('#filters').dataset.handler;
                    filter.apply = () => {
                        filter.applyRecipes()
                        form.closest('.search').classList.remove('input-search');
                        form.closest('.search').classList.remove('focus-search');
                    }
                    filter.applyDebounce();

                }
            }
        })
    }

    InputSearch(input) {
        if(input.value.length > 0) {
            //отобразить блок результата
            input.closest(`.${this.wraperSearch}`).classList.add('input-search')
            //скрыть фильтра в попапе
            if(document.querySelector('.filter-popup').contains(input)) {
                document.querySelector('.filter-popup-content').classList.add('hide')
            }
        }
        else {
            //скрыть блок результата
            input.closest(`.${this.wraperSearch}`).classList.remove('input-search')
            //отобразить фильтра в попапе
            if(document.querySelector('.filter-popup').contains(input)) {
                document.querySelector('.filter-popup-content').classList.remove('hide')
            }
        }
    }

})()
